import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { SideNaveActionsTypes, SideNaveData } from '@klickdata/core/mobile';
import { SideNaveResponseData } from '@klickdata/core/mobile/src/mobile.service';
import { User } from '@klickdata/core/user';
import { TakeResActionValue } from '@klickdata/player/src/next-step.service';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'app-menu-side-take-resource-group-work',
    templateUrl: './menu-side-take-resource-group-work.component.html',
    styleUrls: ['./menu-side-take-resource-group-work.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuSideTakeResourceGroupWorkComponent {
    @Input() public navData: SideNaveData;
    @Output() onClose: EventEmitter<SideNaveResponseData> = new EventEmitter();
    SideNaveActionsTypes = SideNaveActionsTypes;
    TakeResActionValue = TakeResActionValue;
    public showGroupWork: boolean;
    public showGroups: boolean;
    public participantUsers: User[] = [];
    public action: 'done' | 'continueLater' | 'cancel';
    public timeSpendControl: FormControl = new FormControl();

    constructor() {}

    submit() {
        if (this.participantUsers.length == 0) return;
        this.onClose.emit({
            data: {
                action: TakeResActionValue.GROUP_WORK_DONE,
                decision: this.action,
                userIds: this.participantUsers.map((user) => user.id),
                timeSpend:
                    this.timeSpendControl.value && this.action == 'done' ? this.timeSpendControl.value : undefined,
            },
        });
    }
}
